<template lang="html">
    <v-layout class="auth-login">
        <v-flex xs8 offset-xs2 sm6 offset-sm3 md4 offset-md4 lg4 offset-lg4>
            <v-card>
                <v-card-title>
                    <img src="../../assets/img/logo_sidamo.png" />
                </v-card-title>
                <v-card-text>
                    <v-form v-model="valid" ref="form" @submit.prevent="submit">
                        <v-text-field
                            color="accent"
                            label="Adresse email"
                            v-model="model.email"
                            :rules="rules.email"
                            required
                        ></v-text-field>

                        <v-text-field
                            color="accent"
                            label="Mot de passe"
                            type="password"
                            v-model="model.password"
                            :rules="rules.password"
                            required
                        ></v-text-field>

                        <v-btn round color="primary" type="submit" :loading="loading">Se connecter</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-snackbar bottom color="error" v-model="snackbar" @click.native="snackbar = false">
            <v-icon dark class="mr-3">warning</v-icon>
            {{ $store.state.auth.error }}
        </v-snackbar>
    </v-layout>
</template>

<script>
export default {
    data() {
        return {
            valid: false,

            model: {
                email       : '',
                password    : '',
            },

            rules: {
                email: [
                    (v) => !!v || 'Adresse email obligatoire',
                    (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'L\'adresse email n\'est pas valide'
                ],
                password: [
                    (v) => !!v || 'Mot de passe obligatoire',
                ]
            },

            loading: false,
            snackbar: false
        }
    },

    methods: {
        submit() {
            if(this.$refs.form.validate()) {
                this.loading = true
                this.$store.dispatch('clearLoginError')
                this.$store.dispatch('login', this.model)
            }
        }
    },

    watch: {
        '$store.state.auth.error'(val) {
            if(val !== null) {
                this.loading    = false
                this.snackbar   = true
            }
        },

        '$store.state.auth.isConnected'(val) {
            if(val === true) {
                this.$router.push('/')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@require '../../assets/css/variables'

div.card {

    box-shadow: 0 25px 45px 0 #e3e9ef
    border-radius: 1rem

    div.card__title {
        padding: 2.5rem 3.8rem 1.5rem

        img {
            width: 100%
            display: block
            margin: 0 auto
            max-width:240px
        }
    }

    div.card__text {
        padding: 2.5rem 3.8rem

        div.accent--text {
            color: $accent-color!important
        }

        & >>> div.input-group {
            label {
                color: $accent-color
            }

            div.input-group__input {
                input {
                    color: $accent-color
                }
            }



            div.input-group__details {
                &::before {
                    background-color: $accent-color
                }
            }
        }

        & >>> button.btn {
            width: 100%
            margin: 4rem 0 0
            box-shadow: none

            div.btn__content {
                color: #fff
                text-transform: uppercase
                font-weight: 700
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue